import { AutomatedReviewLog } from 'models/automation/Reviews';
import { Row } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import useOpenLeadModal from 'components/domain/lead/modal/useOpenLeadModal';
import { GuestNameCellStyled } from './GuestNameCell.styles';

const GuestNameCell = ({ row }: { row: Row<AutomatedReviewLog> }) => {
  const { updateLeadModal } = useOpenLeadModal();
  const { t } = useTranslation();
  const { guest } = row.original;

  if (!guest) {
    return t('common.notApplicable');
  }

  const handleClickGuest = () => {
    const leadUid = guest.uid;
    if (leadUid) {
      updateLeadModal({ leadUid });
    }
  };

  return (
    <GuestNameCellStyled
      bsStyle="link"
      data-testid="row-guest-name-lead-button"
      onClick={handleClickGuest}
    >
      {guest.name}
    </GuestNameCellStyled>
  );
};

export default GuestNameCell;
